import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue"
import _imports_0 from '../../assets/music/notif.mp3'


const _hoisted_1 = { class: "d-flex align-items-center flex-shrink-0" }
const _hoisted_2 = { class: "me-7" }
const _hoisted_3 = {
  ref: "audio_player",
  controls: "",
  style: {"display":"none"}
}
const _hoisted_4 = /*#__PURE__*/_createElementVNode("source", {
  src: _imports_0,
  type: "audio/mp3"
}, null, -1)
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" Your browser does not support the audio element. ")
const _hoisted_6 = [
  _hoisted_4,
  _hoisted_5
]
const _hoisted_7 = {
  class: "cursor-pointer symbol symbol-30px symbol-md-40px",
  "data-kt-menu-trigger": "click",
  "data-kt-menu-attach": "parent",
  "data-kt-menu-placement": "bottom-end",
  "data-kt-menu-flip": "bottom",
  style: {"position":"relative","display":"inline-block"}
}
const _hoisted_8 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-bell h1" }, null, -1)
const _hoisted_9 = {
  key: 0,
  class: "badge bg-warning",
  style: {"position":"absolute","top":"-5px","right":"-10px","height":"22px","width":"22px","border-radius":"50%","font-size":"8px","padding":"6px 0 0 0"}
}
const _hoisted_10 = {
  class: "d-flex align-items-center ms-1 ms-lg-3",
  id: "kt_header_user_menu_toggle"
}
const _hoisted_11 = /*#__PURE__*/_createElementVNode("div", {
  class: "cursor-pointer symbol symbol-30px symbol-md-40px",
  "data-kt-menu-trigger": "click",
  "data-kt-menu-attach": "parent",
  "data-kt-menu-placement": "bottom-end",
  "data-kt-menu-flip": "bottom"
}, [
  /*#__PURE__*/_createElementVNode("img", {
    src: "/media/avatars/150-26.jpg",
    alt: "metronic"
  })
], -1)
const _hoisted_12 = {
  class: "d-flex align-items-center d-lg-none ms-2 me-n3",
  title: "Show header menu"
}
const _hoisted_13 = {
  class: "btn btn-icon btn-active-light-primary",
  id: "kt_header_menu_mobile_toggle"
}
const _hoisted_14 = { class: "svg-icon svg-icon-1" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_KTNotificationMenu = _resolveComponent("KTNotificationMenu")!
  const _component_KTUserMenu = _resolveComponent("KTUserMenu")!
  const _component_inline_svg = _resolveComponent("inline-svg")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("audio", _hoisted_3, _hoisted_6, 512),
      _createElementVNode("div", _hoisted_7, [
        _hoisted_8,
        (_ctx.notification_count > 0)
          ? (_openBlock(), _createElementBlock("span", _hoisted_9, _toDisplayString(_ctx.unread), 1))
          : _createCommentVNode("", true)
      ]),
      _createVNode(_component_KTNotificationMenu, {
        onNotifChange: _ctx.notifCountChange,
        onNotifOn: _ctx.playNotif
      }, null, 8, ["onNotifChange", "onNotifOn"])
    ]),
    _createElementVNode("div", _hoisted_10, [
      _hoisted_11,
      _createVNode(_component_KTUserMenu)
    ]),
    _createElementVNode("div", _hoisted_12, [
      _createElementVNode("div", _hoisted_13, [
        _createElementVNode("span", _hoisted_14, [
          _createVNode(_component_inline_svg, { src: "/media/icons/duotune/text/txt001.svg" })
        ])
      ])
    ])
  ]))
}